import { DataObject } from '@shared/models/data-object.model';
import { extractCompanies, PreprocessorCompanyContacts } from './preprocessor-company-contacts.interface';

/**
 * Preprocessor service to adjust companies shape with current companies & contact design model
 */
export class PreprocessorCompanyContactsProperty implements PreprocessorCompanyContacts {
  /*
   * TODO: remove this preprocessor once new & flat companies design is implemented.
   */
  processCompanyContacts(record: DataObject): DataObject {
    const usages = record.usages.map(this._extractCompanies);
    const property_development = (record.property_development ?? []).map(this._extractCompanies);

    return { ...record, usages, property_development };
  }

  private _extractCompanies = (target: DataObject & { company_contact_role_addresses: DataObject[] }) => ({
    ...target,
    company_contact_role_addresses: extractCompanies(target.company_contact_role_addresses),
    // * Note(Danny): OG data need it to check companies with merged contacts...
    raw_company_contact_role_addresses: target.company_contact_role_addresses,
  });
}
